import React, { useEffect, useState } from 'react'
import SingleImageUpload from './singleImageUpload';
import EditImage from './editImage';

function ImageUpload({ toggleStates, setToggleStates, editedImageIndex, setEditedImageIndex, setImagesToUpload }) {
    const [selectedImage, setSelectedImage] = useState([]);
    const [directUpload, setDirectUpload] = useState(false)

    // Convert canvas/data-URL images into File objects for FormData submit
    useEffect(() => {
        const imagesWithFiles = [];
        selectedImage.forEach((imageObject, index) => {
            const imageData = imageObject?.src;
            if (!imageData || typeof imageData !== 'string' || !imageData.includes(',')) {
                return;
            }
            try {
                const byteCharacters = atob(imageData.split(',')[1]);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: 'image/png' });
                const file = new File([blob], `image_${index}.png`, { type: 'image/png' });
                imagesWithFiles.push({
                    imageData: imageData,
                    file: file,
                    toggleState: toggleStates[index],
                });
            } catch (err) {
                console.error('Failed to prepare case image for upload', err);
            }
        });
        setImagesToUpload(imagesWithFiles)
    }, [selectedImage, toggleStates, setImagesToUpload])

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const fileSizeLimit = 5 * 1024 * 1024; // 5 MB
            const allowedFileTypes = ['image/jpeg', 'image/png', 'image/svg+xml'];

            if (file.size > fileSizeLimit) {
                alert('File size exceeds the limit of 5MB');
                return;
            }

            if (!allowedFileTypes.includes(file.type)) {
                alert('Invalid file type. Please select a JPG, PNG, or SVG file.');
                return;
            }

            const reader = new FileReader();

            reader.onload = () => {
                const img = new window.Image();
                img.onload = () => {
                    setSelectedImage((prev) => {
                        const next = [...prev, img];
                        setEditedImageIndex(next.length - 1);
                        return next;
                    });
                    setDirectUpload(true);
                };
                img.src = reader.result;
            };
            reader.readAsDataURL(file);
            e.target.value = null
        }
    }

    const handleCancelEdit = () => {
        if (editedImageIndex !== null && directUpload) {
            const updatedSelectedImage = [...selectedImage];
            updatedSelectedImage.splice(editedImageIndex, 1);
            setSelectedImage(updatedSelectedImage);
            setEditedImageIndex(null);
            setDirectUpload(false);
            return;
        }
        setEditedImageIndex(null);
        setDirectUpload(false);
    }

    return (
        <div>
            <article className="widgetWrap uploadCaseWidget">
                <div className="widgetHeader">
                    <span>Case Images</span>
                </div>
                <div className="widgetBody">
                    {((editedImageIndex == null) && selectedImage && (selectedImage.length > 0)) && (
                        <ul className="listUnstyled uploadList">
                            {selectedImage.map((image, index) => (
                                <SingleImageUpload
                                    setEditedImageIndex={setEditedImageIndex}
                                    key={index}
                                    index={index}
                                    image={image}
                                    selectedImage={selectedImage}
                                    setSelectedImage={setSelectedImage}
                                    directUpload={directUpload}
                                    setDirectUpload={setDirectUpload}
                                    toggleStates={toggleStates}
                                    setToggleStates={setToggleStates}
                                />
                            ))}
                        </ul>
                    )}
                    {(editedImageIndex !== null) &&
                        <EditImage
                            directUpload={directUpload}
                            setDirectUpload={setDirectUpload}
                            editedImageIndex={editedImageIndex}
                            setSelectedImage={setSelectedImage}
                            selectedImage={selectedImage}
                            setEditedImageIndex={setEditedImageIndex}
                            image={selectedImage?.find((item, index) => { return (index === editedImageIndex) })}
                        />}
                    {(editedImageIndex === null) && (
                        <div className="uploadBtnWrap">
                            <input onChange={handleFileChange} id="uploadImage" type="file" accept="image/jpeg,image/png,image/svg+xml" className="srOnly" />
                            <label htmlFor="uploadImage" className="label btn btnPrimary">
                                Upload Image <i className="icn fa-solid fa-x-ray"></i>
                            </label>
                        </div>
                    )}
                </div>
                {editedImageIndex !== null && (
                    <div className="widgetFooter">
                        <div className="textCenter">
                            <button type="button" className="btn btnSecondary" onClick={handleCancelEdit}>
                                {directUpload ? 'Remove image' : 'Cancel changes'}
                            </button>
                        </div>
                    </div>
                )}
            </article>
        </div>
    )
}

export default ImageUpload
